export const imageURLWithSize = (imageURI: string, height: number, width: number, scale: number) => {
  if (imageURI.length === 0) {
    return ''
  }

  const w = Math.floor(width * scale)
  const h = Math.floor(height * scale)

  const separator = imageURI.includes('?') ? '&' : '?'
  if (h > 0 && w > 0) {
    return `${process.env.REACT_APP_API_URL}/v1/${imageURI}${separator}y=${h}&x=${w}`
  } else if (h > 0) {
    return `${process.env.REACT_APP_API_URL}/v1/${imageURI}${separator}y=${h}`
  } else if (w > 0) {
    return `${process.env.REACT_APP_API_URL}/v1/${imageURI}${separator}x=${w}`
  } else {
    return `${process.env.REACT_APP_API_URL}/v1/${imageURI}`
  }
}
